import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  analyticsApiRef,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import { NoOpAnalyticsApi } from '@backstage/core-compat-api';
import { MakeAnalyticsApi } from './analytics/MakeAnalyticsApi';
import { SearchCommitAnalyticsApi } from './analytics/SearchCommitAnalyticsApi';
import { sendSearchOutcome } from './analytics/sendSearchOutcome';
import { searchSession } from './analytics/searchSession';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: analyticsApiRef,
    deps: {
      configApi: configApiRef,
      identityApi: identityApiRef,
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    // The new frontend system resolves this API eagerly on route changes, so
    // fall back to a no-op when GA4 is not configured (local dev).
    factory: ({ configApi, identityApi, discoveryApi, fetchApi }) =>
      configApi.getOptionalConfig('app.analytics.ga4')
        ? new SearchCommitAnalyticsApi(
            new MakeAnalyticsApi(
              GoogleAnalytics4.fromConfig(configApi, {
                identityApi,
              }),
            ),
            undefined,
            {
              session: searchSession,
              sendOutcome: outcome =>
                sendSearchOutcome({ discoveryApi, fetchApi }, outcome),
            },
          )
        : new NoOpAnalyticsApi(),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
];
